import AutoRejectFeedback from './AutoRejectFeedback';

export * from './AutoRejectFeedback';
export default AutoRejectFeedback;
